import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneNumber',
  standalone: false,
})
export class PhoneNumberPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) {
      return value;
    } else {
      const trimString = value.trim().replace('+1', '');
      switch (trimString.length) {
        case 7: {
          return trimString.slice(0, 3) + '-' + trimString.slice(3);
        }
        case 10: {
          return (
            '(' +
            trimString.slice(0, 3) +
            ') ' +
            trimString.slice(3, 6) +
            '-' +
            trimString.slice(6)
          );
        }
        default:
          return trimString;
      }
    }
  }
}
